import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SharedService } from "../shared/shared.service";
import { AuthenticationService, UserService } from "../_services";
import { CookieService } from "ngx-cookie";
import { UserContext } from "../_context/user.context";
import { AuthXService, WorkflowStep } from "@authx/authx-workflow-lib";
import { environment } from "@env/environment";
import * as moment from "moment";
import { Alert, AlertTypeEnum } from "../shared/Helpers/Alert";
import { debounceTime, distinctUntilChanged, of, Subject, switchMap, take, takeUntil, tap, timer } from "rxjs";
import { ILastUserAccess, IOAuth2ConfigurationSimpleDto, IOrganisation, IOrganisationInfo, ISamlConfigurationSimpleDto, ISearchRequest, ISimpleOrganisation } from "../shared/interfaces";
import { AuthenticationMethodEnum, AuthenticationMethodEnums } from "../enums/enums";
import { Constants } from "../shared/Helpers/constants";
import { HttpErrorResponse } from "@angular/common/http";
import { HelperFunctions } from "../shared/Helpers/helperFunctions";
import { FederatedAuthenticationService } from "../_services/federated-authentication.service";
import { ISearchParams } from "../shared/interfaces/general.interface";

@Component({
  selector: "able-base-login",
  template: ''
})
export class AbleBaseLoginComponent implements OnInit,  OnDestroy{
  protected organisationId: string = environment.organisation_id;
  public organisationList: any[] = []
  public userNameValidated: any;
  public avatar: string;
  public selectedOrganisationName: string;
  public loading: boolean = false
  public loginModel: any = {}
  public removableOrganization: boolean = false;
  protected LastUserAccess: ILastUserAccess;
  public isLiberateUser: boolean = false;
  public peopleData: any;
  public _destroySubscription$: Subject<void> = new Subject<void>();
  public searchInput$: Subject<ISearchRequest> = new Subject<ISearchRequest>();
  protected ListLastUserAccess: Array<ILastUserAccess>;
  protected returnUrl: string;
  protected currentloginDate: any;
  public loadingOrganisationInfo: boolean = false;


  constructor(
    protected router: Router,
    protected sharedService: SharedService,
    protected authenticationService: AuthenticationService,
    protected cookieService: CookieService,
    protected userContext: UserContext,
    protected authXService: AuthXService,
    protected userService: UserService,
    protected federatedAuthService: FederatedAuthenticationService
  ) {
      this.searchOrganisationsForLogin()


  }
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
      this._destroySubscription$.next()
      this._destroySubscription$.complete()
      // this.searchInput$.complete()
  }
  protected checkIfUserIsAuthenticated = () => {
    if (localStorage.getItem(Constants.localStorage_currentUser)) {
      this.returnUrl = environment.default_return_url;
      if (this.userContext.isAuthenticated && this.userContext.userID && this.userContext.organisationID) {
        this.checkIfSamlRequestExistsInLocalStorage();
      } else {
        localStorage.removeItem(Constants.localStorage_currentUser);
      }
    }

  }

  protected initLastUsersAccess() {
    this.LastUserAccess = {} as ILastUserAccess
    this.ListLastUserAccess = [] as Array<ILastUserAccess>;
  }

  public usernameValidation() {
    this.loading = true
    const selectedOrganisation = this.organisationList.find(org => org.organisationName === this.loginModel.organisation);
    if (!this.organisationId) {
      this.organisationId = selectedOrganisation.id
      this.removableOrganization = true;
    }
    this.userService.checkUsernameAuthenticationWithOrganisation(this.loginModel.username, this.organisationId)
      .pipe(take(1)).subscribe({
      next: (res) => {
        this.userNameValidated = this.loginModel.username;
        this.avatar = res.body.avatar;
        this.sharedService.changeCurrentOrganisationId(this.organisationId);
        this.sharedService.changeUserAttemptedLogin(res.body.homeUserId);
        this.sharedService.changeUserAttemptedLoginUsername(this.loginModel.username);
        this.onUsernameValidationResponse(res.body, selectedOrganisation)
      },
      error: (err) => {
        this.onUsernameValidationError(err, selectedOrganisation?.organisationName)
      }
    })
  }


  protected onUsernameValidationResponse = (response: any, selectedOrganisation: ISimpleOrganisation) => {
    this.loading = false;
    this.checkAuthenticationMethod(response)
  }
  protected checkAuthenticationMethod = (response: any) => {
      this.managedAuthenticationMethod(response)
  }
  protected managedAuthenticationMethod = (response: any) => {
    this.LastUserAccess.avatar = response.avatar;
    this.LastUserAccess.username = this.userNameValidated;
  }
  public handleAuthenticationMethod = (org: IOrganisationInfo) => {
    switch (org.authenticationMethod) {
      case AuthenticationMethodEnums.Managed:
        return of(AuthenticationMethodEnums.Managed)

      case AuthenticationMethodEnums.Federated_Saml:
        return this.federatedAuthService.getSamlOrganisationRegistrationId(org.id).pipe(
          tap((res: ISamlConfigurationSimpleDto[]) => {
            if(res.length > 0)
              this.federatedAuthService.continueSamlConfiguration(res[0].id, this.returnUrl)
          })
        )
      case AuthenticationMethodEnums.Federated_Oauth:
        return this.handleOauth2ProvidersLogin(org.id)
      default:
        break;
    }
  };

  public handleOauth2ProvidersLogin = (organisationId: string, resourceId?: string) => {
    let params: ISearchParams = {
      organisationId: organisationId,
      pageSize: 100,
      page: 1,
      resourceId
    };
  return this.federatedAuthService.getOAuth2OrganisationRegistrationId(params).pipe(
            tap((res: IOAuth2ConfigurationSimpleDto[]) => {
              if(res.some(provider => provider.enabled))
                this.federatedAuthService.continueOAuth2Configuration(res.find(a => a.enabled).registrationId, this.returnUrl)
            })
          )
  }


  protected onUsernameValidationError = (error: any, organisationName: string) => {
    if(error.error.errorCode == 1004) {
      Alert.basicNotification(AlertTypeEnum.Error, "Username error", `The username that you have entered does not exist in ${organisationName}. Please check that you have selected the correct organisation and that the username you entered is correct.`);
    } else {
      Alert.basicNotification(AlertTypeEnum.Error, "Username error", "Username could not be found. Please check your username and try again.");
    }
    this.loading = false;
  }

  protected onUserLogin = () => {
    if(!this.isLoginModelValid()) return;

    this.loading = true;
    this.currentloginDate = moment.utc().subtract(4, 'seconds').toISOString();
    this.sharedService.changeCurrentOrganisationId(this.organisationId);
    this.authenticationService.loginWithAuthenticatingOrganisation(this.loginModel.username, this.loginModel.password, this.organisationId)
      .pipe(take(1)).subscribe({
        next: data => {
          const user = data.body;
          this.sharedService.changeCurrentOrganisationId(null);
          this.saveCookies(user.token);
          this.handleUserLoginResponse(user)
        },
        error: error => {
          this.handleUserLoginError(error)
        }
      })
  }

  protected handleUserLoginResponse = (user: any) => {
     this.storeLoggedUser(user);
     this.loading = false
  }

  protected handleUserLoginError = (error: any) => {
    switch (error.status) {
      case 401: {
        this.handleUnauthenticatedStatus(error);
        break
      }
      case 403: {
        if (error.error.errorCode === 1018) {
          this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
          this.getUserIdByErrorMsg(error.error.detailedMessage);
          this.router.navigateByUrl('/2FA-authentication');
        }
        break
      }
      case 403: {
        if (error.error.errorCode === 1018) {
          this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
          this.getUserIdByErrorMsg(error.error.detailedMessage);
          this.router.navigateByUrl('/2FA-authentication');
        }
        break
      }
      case 0:
      case 404: {
        if (error.status == 404 && error.error.errorCode === 1016) {
          this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
          // 2FA required, but no configurations for 2FA
          this.getUserIdByErrorMsg(error.error.detailedMessage);
          this.router.navigateByUrl('/2FA-setup');
        } else {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "You appear to be offline. Please check your connection and try again.");
          this.loading = false;
        }
        break;
      }
      case 500: {
        if (error.error.errorCode === 1007) {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", error.error.detailedMessage.toString());
          this.loading = false;
        } else {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "An error occurred. Please try again later.");
          this.loading = false;
        }
        break;
      }
      case 422: {
        if (error?.error?.errorCode === 1006) {
          this.handleUnproccessedRequestError(error)
        }
        break
      }
      default:
        this.loading = false
        break;
    }
  }

  private handleUnauthenticatedStatus = (error: any) => {
    switch (error?.error?.errorCode) {
      case 1014: {
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", "You do not currently have permission to log in. Please contact your Able+ administrator if you believe you should have access.");
        break;
      }
      case 1013: {
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Person does not have home user.");
        break
      }
      case 1015: {
        if (error.error.detailedMessage.toString() === 'Organisation is suspended') {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your organisation has been suspended. Please contact your administrator.");
        } else {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", "This user account has been deleted. Please contact your administrator.");
        }
        break
      }
      case 1004: {
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", `The password that you have entered is not correct for "${this.loginModel.username}" in "${this.selectedOrganisationName}". Please check that you have selected the correct organisation and that the password you entered is correct.`);
        break
      }
      case 1070: {
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", error.error.detailedMessage.toString());
        break
      }
      case 1017: {
        this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
        const errMsg: string = error.error.detailedMessage;
        this.getUserIdByErrorMsg(errMsg);
        this.router.navigateByUrl('/2FA-authentication');
        break
      }
      case 1100: {
        this,this.executeAuthXWorkflow(error)
        break
      }
      default:
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Your credentials were not correct. Please check your username and password and try again.");
    }
    this.loading = false;
  }

  private executeAuthXWorkflow = (error: any) => {
    const {executing, responseBody} = this.authXService.execute({
      organisationId: this.sharedService.currentOrganisationId.value,
      workflowStep: error.error.workflowStep as WorkflowStep,
      onSuccess: token => {
        localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify({token: token}));
        this.getPeopleData();
      }
    });
    executing.pipe(take(1)).subscribe({
        next: value => {if (value == false) this.loading=false},
        error: _ => this.loading=false
    });

    responseBody.pipe(take(1)).subscribe({
      next: body => {
        if (body instanceof HttpErrorResponse) {
          Alert.basicNotification(AlertTypeEnum.Error, "Login error", body.error.message ?? "Your credentials were not correct. Please check your username and password and try again.");
        }
      }
    })
  }

  protected handleUnproccessedRequestError = (error: any) => {
    const currentUser = new UserContext();
    this.sharedService.setErrorMsg(error.error.detailedMessage);
    if (!this.sharedService.loggedUserId.value) {
      this.userService.getHomeUser(currentUser.personID)
        .pipe(take(1)).subscribe({
        next: (res) => {
          const userId = res.body.find((usr: any) => usr.organisation.id == this.organisationId).id;
          if (userId) {
            this.sharedService.changeLoggedUserId(userId)
          } else {
            this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
          }
        },
        error: (err) => {
          this.sharedService.changeLoggedUserId(this.peopleData.homeUser.id)
        },
        complete: () => {
          this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
          this.router.navigateByUrl('/2FA-authentication');
        }
      })
    } else {
      this.sharedService.changeUserAttemptedLoginPassword(this.loginModel.password);
      this.router.navigateByUrl('/2FA-authentication');
    }
  }


  protected getUserIdByErrorMsg(errMsg: any) {
    const userId: string = errMsg.substr(errMsg.indexOf('\'') + 1, 36);
    this.sharedService.changeLoggedUserId(userId);
  }
  private isLoginModelValid(): boolean {
    if ((this.loginModel.username != undefined && this.loginModel.username != undefined) && (this.loginModel.password != undefined && this.loginModel.password != undefined)) {
      return true;
    }
    return false;
  }

  protected storeLoggedUser = (user: any) => {
    if (user && user.token) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
    }
    this.getPeopleData()
  }

  protected checkUsernameOnLocalStorage(userAccess: ILastUserAccess) {
    if (localStorage.getItem(Constants.localStorage_ListUsers) != undefined && localStorage.getItem(Constants.localStorage_ListUsers).length > 0) {
      let LastUserLoggedIn = localStorage.getItem(Constants.localStorage_ListUsers);
      this.ListLastUserAccess = JSON.parse(LastUserLoggedIn)
      this.ListLastUserAccess = this.ListLastUserAccess.slice(Constants.minUsersList, Constants.maxUsersList);
      // check if exist;
      if (this.ListLastUserAccess.filter(item => item.username == userAccess.username).length == 0) {
        if (this.ListLastUserAccess.length < 5) {
          this.ListLastUserAccess.push(userAccess)
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));

        } else {
          this.ListLastUserAccess.slice(Constants.maxUsersList);
          this.ListLastUserAccess.push(userAccess)
          localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
        }
      } else {
        // remove
        this.ListLastUserAccess = this.ListLastUserAccess.filter(item => item.username != userAccess.username)
        // push again(get updated avatar)
        this.ListLastUserAccess.push(userAccess);
        localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
      }

    } else {
      this.ListLastUserAccess.push(userAccess);
      localStorage.setItem(Constants.localStorage_ListUsers, JSON.stringify(this.ListLastUserAccess));
    }
  }

  protected saveCookies = (token: string) => {
    // add cookie
    let idamUrl: string = environment.identityCookieUrl;
    idamUrl = idamUrl.substr(idamUrl.indexOf('//') + 2);
    idamUrl = idamUrl.substr(0, idamUrl.indexOf(':'));
    if (idamUrl.indexOf('.') > -1) {
      idamUrl = idamUrl.substr(idamUrl.indexOf('.'));
    }
    this.cookieService.put('ABLEIDENTITY', token, {path: '/', expires: moment(new Date()).add(30, 'm').toDate(), domain: idamUrl});
  }

  public getOrganisationInfo = (organisationId: string) => {
    // this.loadingOrganisationInfo = true;
    // this.authenticationService.getOrganisationInfo(organisationId)
    // .pipe(
    //   takeUntil(this._destroySubscription$),
    //   switchMap(response => {
    //     return this.handleAuthenticationMethod(response)
    //   })
    // )
    // .subscribe(
    //   {
    //     next: res =>{
    //       this.loadingOrganisationInfo = false
    //     },
    //     error: error => {
    //       console.log(error);
    //     }
    //   }
    // )
  };

  protected getPeopleData = () => {
    /**
     * Empty methods are user as a reference on child classes,
     * real implementation will be in children
     */
  }

  protected checkIfSamlRequestExistsInLocalStorage = () => {
    /**
     * Empty methods are user as a reference on child classes,
     * real implementation will be in children
     */
  }

  protected searchOrganisationsForLogin = () => {
      this.searchInput$
    .pipe(
      // debounceTime(300),
      distinctUntilChanged(),
      switchMap(request => {
        const searchParams: string = HelperFunctions.buildSearchParamsString(request.searchString, 1, request?.pageSize || 10);
        return this.userService.getAllOrganisationsForLogin(searchParams, request?.organisationIds || [])
          .pipe(takeUntil(this._destroySubscription$));
      })
    )
    .subscribe({
      next: (organisationPage) => {
        this.organisationList = organisationPage.data.map((org: any) => {
          if (org.parentName)
            org.organisationName = `${org.organisationName} (${org.parentName})`;
          org = { ...org, name: org.organisationName };
          if (org.id === this.organisationId) {
            this.selectedOrganisationName = org.organisationName;
            this.loginModel.organisation = this.selectedOrganisationName;
          }
          return org;
        });
      },
      error: () => {
        Alert.basicNotification(AlertTypeEnum.Error, "Login error", "Failed to get login organisations!");
      }
    });

  }
}
